import {
    createRouter,
    createWebHistory
} from 'vue-router'
import VueCookies from 'vue-cookies'
import store from '../store/index.js'
import $ from "jquery";
import baseUrl from '@/api/config.js'

let districtName = ''
//区分是江苏还是山东或是青海
let host = window.location.host.split(".")
let folder = (host[0] == 'zaozhuang' || host[0] == 'laiwu') && host[1]=='21ys' ? "22ys" : host[1];
let openYear = Number('20' + folder.substring(0, 2))
let openType = folder.substring(2, 4)
store.store.commit('changeopenYear', openYear)
store.store.commit('changeopenType', openType)
if (host[0] == "wenzhou") {
    VueCookies.set("district", "浙江")
    localStorage.setItem("district", "浙江")
    if (!VueCookies.get("session") && !localStorage.getItem('session')) {
        $.ajax({
            type: 'POST', 
            url: `${baseUrl.baseUrl.dev}user/login`,
            headers: {
                "Content-type": "application/json; charset=utf-8"
            },
            dataType: 'json',
            data: JSON.stringify({ id: "lh", password: "123" }),
            success: function (res) {
                if (res.status == 0) {
                    VueCookies.set("session", res.session)
                    localStorage.setItem('session', res.session)
                    VueCookies.set("zone","a77a9f56a50a49b199ce3fce354db5f7")
                    localStorage.setItem("zone", "a77a9f56a50a49b199ce3fce354db5f7")
                }
            }
        })
    }
}
if(VueCookies.get("district") == null){
    $.ajax({
        type:'GET',
        url: `${baseUrl.baseUrl.dev}zones?code=${host[0]}&year=${openYear}&type=${openType}`,
        async:false,
        headers: { 'session': sessionStorage.getItem("session") ?? VueCookies.get("session") ?? localStorage.getItem('session')},
        success:function(res){
            if(res.status == 0){
                districtName = res.zones[0].district
                if (!sessionStorage.getItem("zone")) {
                    sessionStorage.setItem("zone", res.zones[0].id)
                }
            }
        }
    })
}else{
    districtName = VueCookies.get("district")
}


let fileName = "";
if (districtName == "山东") {
    fileName = "shandong";
} else if (districtName == "青海") {
    fileName = "qinghai";
} else if (host[0] == 'wenzhou' || districtName == "浙江") {
    fileName = "zhejiang";
} else if (districtName == "江苏") {
    fileName = "";
}



const routes = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/divs',
        name: 'divs',
        component: () => import( /* webpackChunkName: "divs" */ '../views/divs.vue')
    },
    {
        path: '/div',
        name: 'div',
        component: () => import( /* webpackChunkName: "div" */ '../views/div.vue'),
        children: [
            {
                path: `/div/deptSurvey`,
                name: '部门概况',
                component: () => import(/* webpackChunkName: "deptSurvey" */'../views/' + folder+'/div' + fileName + '/' + 'deptSurvey.vue'),
            }, {
                path: '/div/table/:id',
                name: '表格',
                component: () => import(/* webpackChunkName: "table" */'../components/' + folder+'/table' + fileName + '/' + 'index.vue'),
            }, {
                path: `/div/qksm`,
                name: '情况说明',
                component: () => import(/* webpackChunkName: "qksm" */'../views/' + folder +'/div' + fileName + '/' + 'qksm.vue'),
            }, {
                path: '/div/mcjs',
                name: '名词解释',
                component: () => import(/* webpackChunkName: "mcjs" */'../views/' + folder +'/div' + fileName + '/' + 'mcjs.vue'),
            }, {
                path: '/div/uploadPerform',
                name: '绩效文件',
                component: () => import(/* webpackChunkName: "uploadPerform" */'../components/uploadPerform.vue'),
            }, {
                path: '/div/personalPdf',
                name: '上传PDF',
                component: () => import(/* webpackChunkName: "personalPdf" */'../components/personalpdf.vue'),//用户上传自己的PDF
            },{
                path: '/div/importView',
                name: '导入公开表',
                component: () => import(/* webpackChunkName: "importView" */'../components/importTable/importView.vue'),
            }, {
                path: '/div/downImportTable',
                name: '下载公开表',
                component: () => import(/* webpackChunkName: "downImportTable" */'../components/importTable/downImportTable.vue'),
            }, {
                path: '/div/userInformation',
                name: '填报人员联系方式',
                component: () => import(/* webpackChunkName: "userInformation" */'../components/userInformation.vue'),
            }, {
                path: '/div/lastDetail',
                name: '去年数据',
                component: () => import(/* webpackChunkName: "lastDetail" */'../views/' + folder +'/div/lastDetail.vue'),
            }, {
                path: '/div/gksjcurrent',
                name: '修改公开时间',
                component: () => import(/* webpackChunkName: "gksjcurrent" */'../views/config/gksjcurrent.vue'),
            }]
    },
    {
        path: '/user',
        name: 'user',
        component: () => import(/* webpackChunkName: "user" */'../views/user.vue'),
        children: [{
            path: '/user/unitList',
            name: '单位列表',
            component: () => import(/* webpackChunkName: "user" */'../views/user/unit/unitList.vue'),
        }, {
            path: '/user/unitAdd',
            name: '添加单位',
            component: () => import(/* webpackChunkName: "user" */'../views/user/unit/unitAdd.vue'),
        }, {
            path: '/user/unitImport',
            name: '导入单位',
            component: () => import(/* webpackChunkName: "user" */'../views/user/unit/unitImport.vue'),
        },
        {
            path: '/user/BatchImport',
            name: '批量导出公开表',
            component: () => import(/* webpackChunkName: "user" */'../views/user/unit/BatchImport.vue'),
        }, 
        {
            path: '/user/departmentList',
            name: '科室列表',
            component: () => import(/* webpackChunkName: "user" */'../views/user/department/departmentList.vue'),
        }, {
            path: '/user/departmentAdd',
            name: '添加科室',
            component: () => import(/* webpackChunkName: "user" */'../views/user/department/departmentAdd.vue'),
        }, {
            path: '/user/userList',
            name: '用户列表',
            component: () => import(/* webpackChunkName: "user" */'../views/user/user/userList.vue'),
        }, {
            path: '/user/userAdd',
            name: '添加用户',
            component: () => import(/* webpackChunkName: "user" */'../views/user/user/userAdd.vue'),
        }, {
            path: '/user/cms',
            name: 'cms集成',
            component: () => import(/* webpackChunkName: "config" */`../views/user/cms/cms.vue`),
        }]
    },
    //用户操作
    {
        path: '/import',
        name: 'import',
        component: () => import( /* webpackChunkName: "import" */ '../views/import.vue'),
    },
    {
        path: '/password',
        name: 'password',
        component: () => import( /* webpackChunkName: "password" */ '../views/password.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import( /* webpackChunkName: "login" */ '../views/login.vue'),
    },
    {
        path: '/username',
        name: 'username',
        component: () => import( /* webpackChunkName: "username" */ '../views/username.vue'),
    },
    {
        path: '/config',
        name: 'config',
        component: () => import( /* webpackChunkName: "config" */'../views/config'),
        children: [{
            path: '/config/gksj',
            name: '公开时间',
            component: () => import(/* webpackChunkName: "config" */`../views/config/gksj.vue`),
        }, {
            path: '/config/importingProfile',
            name: '导入表配置',
            component: () => import(/* webpackChunkName: "config" */`../views/config/importing-profile.vue`),
        }, {
            path: '/config/passwordStrategy',
            name: '密码策略',
            component: () => import(/* webpackChunkName: "config" */`../views/config/password-strategy.vue`),
        }, {
            path: '/config/pdfConfig',
            name: 'pdf配置',
            component: () => import(/* webpackChunkName: "config" */`../views/config/pdfConfig.vue`),
        }, {
            path: '/config/cmsConfig',
            name: 'cms配置',
            component: () => import(/* webpackChunkName: "config" */`../views/config/cmsConfig.vue`),
        }, {
            path: '/config/MutateTableProfile',
            name: '公开表配置',
            component: () => import(/* webpackChunkName: "config" */`../views/config/MutateTableProfile.vue`),
        }, {
            path: '/config/maintainConfig',
            name: '维护配置',
            component: () => import(/* webpackChunkName: "config" */`../views/config/maintainConfig.vue`),
        }, {
            path: '/config/cloneProject',
            name: 'cloneProject',
            component: () => import( /* webpackChunkName: "cloneProject" */ `../views/config/cloneProject`),
        }, {
            path: '/config/editProject',
            name: 'editProject',
            component: () => import( /* webpackChunkName: "editProject" */ `../views/config/editProject`),
        }, {
            path: '/config/deleteProject',
            name: 'deleteProject',
            component: () => import( /* webpackChunkName: "deleteProject" */ `../views/config/deleteProject`),
        },]
    },
    {
        path: '/admin',
        name: 'admin',
        component: () => import( /* webpackChunkName: "config" */'../views/admin'),
        children: [{
            path: '/admin/bdata',
            name: 'bdata',
            component: () => import(/* webpackChunkName: "config" */`../views/admin/bdata.vue`),
        }, {
            path: '/admin/tableProfile',
            name: '表格配置',
            component: () => import(/* webpackChunkName: "config" */`../views/admin/table-profile.vue`),
        }, {
            path: '/admin/toConfigTable',
            name: '配置表格数据',
            component: () => import( /* webpackChunkName: "toConfigTable" */ `../views/admin/toConfigTable`),
        }, {
            path: '/admin/role',
            name: '角色权限',
            component: () => import(/* webpackChunkName: "user" */'../views/admin/userconfig.vue'),
        }]
    },
    {
        path: '/support/supTableProfile',
        name: 'tableProfile',
        component: () => import( /* webpackChunkName: "support" */ '../views/support/supTableProfile'),
    },
    {
        path: '/pdfHtml',
        name: 'pdfHtml', 
        component: () => import( /* webpackChunkName: "pdfHtml" */ '../views/' + folder + '/div' + fileName + '/' + 'pdfHtml.vue'),
    },
    {
        path: '/zcgk',
        name: 'zcgk',
        component: () => import( /* webpackChunkName: "zcgk" */ '../views/dafeng/zcgk'),
    },
    {
        path: '/gusuPifu',
        name: 'gusuPifu',
        component: () => import( /* webpackChunkName: "pifu" */ '../components/pifu/gusuPifu'),
    },{
        path: '/hanjiangPifu',
        name: 'hanjiangPifu',
        component: () => import( /* webpackChunkName: "pifu" */ '../components/pifu/hanjiangPifu'),
    }, {
        path: '/public',
        name: '公开页面',
        component: () => import( /* webpackChunkName: "pifu" */ '../views/public/index'),
    }, {
        path: '/public/divs',
        name: '公开页面子页面',
        component: () => import( /* webpackChunkName: "pifu" */ '../views/public/publicDiv'),
    }, {
        path: '/public/div',
        name: '公开页面详情页面',
        component: () => import( /* webpackChunkName: "pifu" */ '../views/public/publicDetail'),
    }, {
        path: '/user/cms/article',
        name: '文章',
        component: () => import(/* webpackChunkName: "config" */`../views/user/cms/article.vue`),
    }, {
        path: '/:catchAll(.*)',
        name: '404',
        component: () => import( /* webpackChunkName: "404" */ '../components/404'),
    },

]

const router = createRouter({

    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router